/**
 * @desc 报警处理-关闭
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.BackToThe,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/personal/warning/close',
    data,
  });
}

export function mock(data: defs.BackToThe): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/personal/warning/close',
    data,
  });
}
